//買い物関連のスクリプト
(function($) {
  'use strict';


  var connecting = false;
  function ajaxCompareShopping( self , callback ) { 
    //console.log( 'req shopping '+self.data('asin'));
    
    if ( !self.data('nonce') ) {
      return;
    }

    //他の接続が終わるのを待つ
    if ( connecting ) {
      setTimeout( function() {
        ajaxCompareShopping( self, callback );
      },100);
      return;
    }


    connecting = true;
    var data = {
        'action': 'shopping_compare',
        '_ajax_nonce': self.data('nonce'),
        'jan': self.data('jan'),
        'asin': self.data('asin'),
        'keyword': self.data('keyword'),
        'type' : self.data('type'),
        'hide' : self.data('hide'),
        'cache' : self.data('cache'),
        'style': self.data('style'),
        'only_available' : self.data('only_available'),
        'version' : self.data('version'),
        'is_new_template_v2' : self.data('is_new_template_v2'),
    };
    //console.log(data);
    return $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'text',
      timeout: 30000,
      cache : false,
      data: data,
    }).fail(function(xhr, status, error) {
      console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
      console.error('通信エラー');
      self.find('.message').text('価格の読み込みに失敗しました');
      //alert('通信エラー');
    }).done(function(data) {
      //console.log('req done '+self.data('asin'));
      if ( self && data ) {
        self.html(data);
        moko.initEvents(self);
        // shopping shortcodeの価格比較HTMLはAjax後に挿入されるため、
        // 挿入後のログインユーザー向け運営UI placeholderを再走査する。
        if (window.moko && typeof moko.loadOperationsFragments === 'function') {
          moko.loadOperationsFragments(self.get(0));
        }
      }
    }).always(function() {
      connecting = false;
      callback();
    });
  }



  //最初から見えてるバーション
  $('.shopping-compare').each( function( ) {
    var self = $(this);
    ajaxCompareShopping(self, function() {
    } );
  });


  //ボタンリンクバージョン
  $('.shopping-compare-link').one( 'click', function() {
    var btn =$(this).find('.btn-shopping-compare');
    var container = $(this).find('.shopping-compare-hide');
    container.show();
    ajaxCompareShopping(container,function() {
      btn.hide();
    });
  });

})(jQuery);

// Amazon / Shopping 運営fragmentの操作をAjax挿入後も有効にする。
(function($) {
  'use strict';

  var operations = {
    '.amazon-list-cache-clear-button': {
      root: '.amazon-list-cache-clear-operations, .amazon-list-cache-clear-admin', message: '.amazon-list-cache-clear-message',
      action: 'moko_amazon_list_clear_cache', fields: function(root, nonce) {
        return { filters: parseFilters(root), version: 3, nonce: nonce };
      }
    },
    '.shopping-ranking-cache-clear-button': {
      root: '.shopping-ranking-cache-clear-operations, .shopping-ranking-cache-clear-admin', message: '.shopping-ranking-cache-clear-message',
      action: 'moko_shopping_ranking_clear_cache', fields: function(root, nonce) {
        return { filters: parseFilters(root), nonce: nonce };
      }
    },
    '.shopping-logs-cache-clear-button': {
      root: '.shopping-logs-cache-clear-operations, .shopping-logs-cache-clear-admin', message: '.shopping-logs-cache-clear-message',
      action: 'moko_shopping_logs_clear_cache', fields: function(root, nonce) {
        return { filters: parseFilters(root), nonce: nonce };
      }
    },
    '.shopping-calendar-cache-clear-button': {
      root: '.shopping-calendar-cache-clear-operations, .shopping-calendar-cache-clear-admin', message: '.shopping-calendar-cache-clear-message',
      action: 'moko_shopping_calendar_clear_cache', fields: function(root, nonce) {
        return { filters: parseFilters(root), nonce: nonce };
      }
    },
    '.ranking-games3-cache-clear-button': {
      root: '.ranking-games3-cache-clear-operations, .ranking-games3-cache-clear-admin', message: '.ranking-games3-cache-clear-message',
      action: 'moko_ranking_games3_clear_cache', fields: function(root, nonce) {
        return {
          api_env: root.attr('data-api-env') || 'production',
          tag_name: root.attr('data-tag-name') || '',
          count: root.attr('data-count') || 100,
          only_reservation: root.attr('data-only-reservation') === '1',
          nonce: nonce
        };
      }
    }
  };

  function parseFilters(root) {
    try {
      return JSON.parse(root.attr('data-filters') || '{}');
    } catch (error) {
      return null;
    }
  }

  function findOperation(target) {
    var selector;
    for (selector in operations) {
      if (operations.hasOwnProperty(selector) && $(target).closest(selector).length) {
        return { button: $(target).closest(selector), operation: operations[selector] };
      }
    }
    return null;
  }

  $(document).on('click', '.amazon-list-cache-clear-button, .shopping-ranking-cache-clear-button, .shopping-logs-cache-clear-button, .shopping-calendar-cache-clear-button, .ranking-games3-cache-clear-button', function(event) {
    event.preventDefault();
    var found = findOperation(event.target);
    if (!found) { return; }
    var button = found.button;
    if (button.hasClass('disabled')) { return; }
    var operation = found.operation;
    var root = button.closest(operation.root);
    var message = root.find(operation.message);
    var nonce = root.attr('data-nonce') || '';
    var fields = operation.fields(root, nonce);
    if (!window.moko || !moko.ajaxurl || !nonce || fields.filters === null) {
      message.text('削除条件の解析に失敗しました');
      return;
    }
    button.addClass('disabled').css('pointer-events', 'none');
    message.text('削除中...');
    $.ajax({
      url: moko.ajaxurl, type: 'POST', dataType: 'json', timeout: 30000, cache: false,
      data: { action: operation.action, request: JSON.stringify(fields) }
    }).done(function(response) {
      if (response && response.success) {
        message.text('削除しました。再読み込みします...');
        setTimeout(function() { window.location.reload(); }, 300);
        return;
      }
      message.text(response && response.data && response.data.message ? response.data.message : '削除に失敗しました');
      button.removeClass('disabled').css('pointer-events', '');
    }).fail(function(xhr, status) {
      if (operation.action === 'moko_ranking_games3_clear_cache') {
        // 応答なし・破損・proxy errorから削除の成否を推測して再送しない。
        var httpStatus = xhr.status || 0;
        var rejected = (httpStatus === 400 || httpStatus === 403 || httpStatus === 405)
          && xhr.responseJSON && xhr.responseJSON.success === false;
        var reason = rejected && xhr.responseJSON.data && xhr.responseJSON.data.message;
        message.text(rejected
          ? '削除要求が拒否されました（HTTP ' + httpStatus + '）: ' + (reason || '条件を再確認してください')
          : '削除結果は未確認です（HTTP ' + httpStatus + ' / ' + (status === 'timeout' ? 'timeout' : status === 'parsererror' ? 'parsererror' : 'error') + '）。再送せず応答・キャッシュ状態を確認してください');
        button.attr('aria-disabled', 'true');
        return;
      }
      message.text('通信エラーが発生しました');
      button.removeClass('disabled').css('pointer-events', '');
    });
  });

  $(document).on('click', '.amazon-list-params-toggle-button, .shopping-ranking-params-toggle-button, .shopping-logs-params-toggle-button, .shopping-calendar-params-toggle-button, .ranking-games3-params-toggle-button', function(event) {
    event.preventDefault();
    var button = $(event.target);
    var root = button.closest('.login-user-content, .admin-content');
    var panel = root.find('.amazon-list-debug-params, .shopping-ranking-debug-params, .shopping-logs-debug-params, .shopping-calendar-debug-params, .ranking-games3-debug-params');
    panel.slideToggle(150);
  });
})(jQuery);
